import React, { useRef, useEffect, useCallback } from 'react'
import ReactTooltip from 'react-tooltip'

import PropTypes from 'prop-types'

import './Tooltip.scss'

export const Tooltip = ({ children, place, ...props }) => {
  /*

  const tooltipRef = useRef(null)

  const handleResize = useCallback(() => {
    tooltipRef.current && tooltipRef.current.updatePosition()
  }, [])

  useEffect(() => {
    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
  }, [])

  // ref={tooltipRef}
  */

  const html = !children

  return (
    <ReactTooltip
      type='light'
      effect='solid'
      place={place}
      desiredPlace={place}
      html={html}
      className='c-tooltip'
      delayShow={100}
      {...props}
    >
      {children}
    </ReactTooltip>
  )
}

Tooltip.propTypes = {
  children: PropTypes.node,
  place: PropTypes.oneOf(['top', 'right', 'bottom', 'left'])
}

export const TooltipUtils = ReactTooltip
